import React, { useEffect, useState } from 'react';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import { styled } from '../../assets/theme';

const ConnectionBadge: React.FunctionComponent<{className?: string}> = ({ className }) => {
  const [connected, setConnected] = useState<number>();
  const [authenticated, setAuthenticated] = useState<boolean | undefined>();
  useEffect(() => {
    
    subscribeListener('store:authenticated', 1, ({ data }) => {
      setConnected(WebSocket.OPEN);
      setAuthenticated(data.isAuthenticated);
    });

    return () => {
      unsubscribeListener('store:connected', 1)
      unsubscribeListener('store:authenticated', 1)
    }
  }, []);

  return (
    <StatusCircleContainer connected={connected} authenticated={authenticated}>
      <StatusCircle connected={connected} authenticated={authenticated} />
      <StatusLabel connected={connected} authenticated={authenticated} />
    </StatusCircleContainer>
  );
};

export const StatusCircleContainer = styled.div<{connected?: number, authenticated?: boolean}>`
  user-select: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-items: end;
  margin-right: 10px;
  font-size: 11px;
  color: ${({ theme, connected, authenticated }) => (connected === WebSocket.OPEN ? authenticated ? theme.template.green.normal : theme.template.yellow.normal : theme.template.red.normal)};
`;

const StatusCircleCore: React.FunctionComponent<{className?: string, fillColor?: string }> = ({ className, fillColor }) => {
  return (
    <div style={{ width: '7px' }}>
      <svg className={className} viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='5' cy='5' r='5' />
      </svg>
    </div>
  );
};

const StatusLabelCore: React.FunctionComponent<{className?: string, connected?: number, authenticated?: boolean }> = ({ className, connected, authenticated }) => (
  <span className={className}>{connected === WebSocket.OPEN ? authenticated ? 'Connected' : 'Not logged in' : 'Disconnected'}</span>
);

export const StatusCircle = styled(StatusCircleCore)<{connected?: number, authenticated?: boolean}>`
  circle {
    fill: ${({ theme, connected, authenticated }) => (connected === WebSocket.OPEN ? authenticated ? theme.template.green.normal : theme.template.yellow.normal : theme.template.red.normal)};
  }
`;

export const StatusLabel = styled(StatusLabelCore)`
  margin-left: 4px;
`;

export default ConnectionBadge;
